module.exports = __webpack_public_path__ + "pc/img/banner.6be11c08.jpg";